import useVToast from "@composables/use-v-toast";
import i18n from "@shared/locale/i18n.js";

const t = i18n.global.t;

export const formErorHandler = async (errors, formErrors) => {
  if (errors?.response?.status === 422) {
    if (errors.response.data?.data?.type === "api_error") {
      return useVToast({
        title: errors.response.data.data.message,
        type: "warning",
      });
    }
    useVToast({
      title: t("messages.check_form_data"),
      type: "warning",
    });

    if (formErrors) formErrors.save(errors);
  } else if (errors?.response?.status >= 500) {
    console.error("server error", errors);
    useVToast({
      title: t("messages.server_error"),
      type: "error",
    });
  } else {
    console.error("error", errors);
    useVToast({
      title: t("messages.unexpected_error"),
      type: "warning",
    });
  }
};
